export default __webpack_public_path__ + "static/2ec5a338f184401e7ca592e9587c6af2.png";